import {useEffect} from "react";
import {handleClientParameters} from "../analytics";
import {useInjection} from "brandi-react";
import {AuthModelStoreToken} from "../../../entities/auth/model";
import {GlobalModelStoreToken} from "../../models/global";

export const useHandleClientParameters = (clientID) => {
    const authModel = useInjection(AuthModelStoreToken);
    const globalM = useInjection(GlobalModelStoreToken);

    const isLoggedIn = authModel.isLoggedIn();
    const userId = globalM.get().userId

    useEffect(() => {
        if (clientID && userId) {
            handleClientParameters(clientID);
        }
    }, [clientID, isLoggedIn, userId]);
}